// extracted by mini-css-extract-plugin
export default {"number":"kVD3"};